module.exports = __webpack_public_path__ + "static/media/agent.cffbf417.svg";